export default __webpack_public_path__ + "static/media/SZ09.2390b19a.mp3";